import { GenIcon } from '../helpers/IconBase.es.js';

const HamburgerOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.25 6.5C2.25 6.08579 2.58579 5.75 3 5.75H21C21.4142 5.75 21.75 6.08579 21.75 6.5C21.75 6.91421 21.4142 7.25 21 7.25H3C2.58579 7.25 2.25 6.91421 2.25 6.5ZM2.25 11.5C2.25 11.0858 2.58579 10.75 3 10.75H21C21.4142 10.75 21.75 11.0858 21.75 11.5C21.75 11.9142 21.4142 12.25 21 12.25H3C2.58579 12.25 2.25 11.9142 2.25 11.5ZM3 15.75C2.58579 15.75 2.25 16.0858 2.25 16.5C2.25 16.9142 2.58579 17.25 3 17.25H13C13.4142 17.25 13.75 16.9142 13.75 16.5C13.75 16.0858 13.4142 15.75 13 15.75H3Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { HamburgerOutlined };
